
<!--==================================
=            WIDGETS LIST            =
===================================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Widgets List</div>
      </base-header>
    </v-row>

    <v-row>
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">

            <v-list-item dark three-line>
              <v-list-item-avatar tile size="80" class="rounded-lg white--text" color="primary ">
                <v-icon size="50" dark>extension</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <div class="mt-2 white--text font-weight-bold mb-1">
                  $67.000
                </div>
                <v-list-item-title class="subtitle-1  font-weight-bold mb-1">

                  Project Meeting
                </v-list-item-title>
                <v-list-item-subtitle class="">Group lunch celebration</v-list-item-subtitle>
              </v-list-item-content>


            </v-list-item>
          </div>
          <div slot="card-body">

          </div>
        </base-card>
      </v-col>
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">
            <v-list-item dark three-line>
              <v-list-item-avatar tile size="80" class="rounded-lg white--text" color="primary ">
                <v-icon size="50" dark>view_in_ar</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <div class="mt-2 white--text font-weight-bold mb-1">
                  $56,000
                </div>
                <v-list-item-title class="subtitle-1 font-weight-bold mb-1">
                  Statistics
                </v-list-item-title>
                <v-list-item-subtitle>Over 500 members
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
          <div slot="card-body">
          </div>
        </base-card>
      </v-col>
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">
            <v-list-item dark three-line>
              <v-list-item-avatar tile size="80" class="rounded-lg" color="primary ">
                <v-icon size="50" dark>shopping_cart</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <div class="mt-2 white--text font-weight-bold mb-1">
                  $67.000
                </div>
                <v-list-item-title class="subtitle-1 font-weight-bold mb-1">

                  Project Meeting
                </v-list-item-title>
                <v-list-item-subtitle>Group lunch celebration</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
          <div slot="card-body">

          </div>
        </base-card>



      </v-col>
      <v-col cols="12" md="6" sm="12">
        <base-card>
          <div slot="card-header">
            Table User Twitter
          </div>
          <div slot="card-subheader">Commodo sit veniam enim aute mollit ut qui.</div>
          <div slot="card-body">
            <v-data-table v-model="selected" :headers="headers" :items="desserts" :single-select="singleSelect"
                          item-key="name" show-select
                          class="elevation-0  text-capitalize card-light   font-weight-medium">
              <template v-slot:item.name="{ item }">
                <v-avatar size="40" class="mb-1 rounded-lg">
                  <img :src="require(`../../assets/images/users/${item.img}.jpg`)" alt="John">
                </v-avatar> {{item.name||to.Uppercased}}
              </template>

              <template v-slot:item.status="{ item }">
                <v-chip :color="getColor(item.status)" label dark>
                  {{ item.status }}
                </v-chip>
              </template>
              <template v-slot:item.profit="{ item }">
                <v-chip :color="getColor2(item.profit)" dark outlined label>

                  {{ item.profit}}%
                </v-chip>
              </template> <template v-slot:item.profit="{ item }">
                <v-chip :color="getColor2(item.loss)" dark outlined label>

                  {{ item.loss}}%
                </v-chip>
              </template>


            </v-data-table>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="6" sm="12">
        <base-card>
          <div slot="card-header">

            List User
          </div>
          <div slot="card-subheader">Commodo sit veniam enim aute mollit ut qui.</div>
          <div slot="card-body">



            <v-list-item color="transparent" v-for="folder in list1" :key="folder.title">
              <v-list-item-avatar class="rounded-lg" :color="folder.color" size="40">
                <v-icon size="30" dark>{{folder.icon}}</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title class=" subtitle-1 font-weight-bold" v-text="folder.title">
                </v-list-item-title>

                <v-list-item-subtitle v-text="folder.subtitle"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-switch v-model="folder.switch1" inset></v-switch>

              </v-list-item-action>
            </v-list-item>



          </div>
        </base-card>
      </v-col>
 
      <v-col cols="12" md="4" sm="12">
        <base-card>
          <div slot="card-header">

            Weather forecast
          </div>
          <div slot="card-subheader">Commodo sit veniam enim aute mollit ut qui.</div>
          <div slot="card-body">
            <v-list-item dark two-line>
              <v-list-item-content>
                <v-list-item-title class="text-h6">
                  San Francisco
                </v-list-item-title>
                <v-list-item-subtitle>Mon, 12:30 PM, Mostly sunny</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-card-text>
              <v-row class="center ">
                <v-col class="text-h3" cols="7">
                  $158
                </v-col>
                <v-col cols="5">
                  <v-img src="../../assets/images/icon/home.png" alt="Sunny image" width="102"></v-img>
                </v-col>
              </v-row>
            </v-card-text>


          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="4" sm="12">
        <base-card>
          <div slot="card-header">

            Weather forecast
          </div>
          <div slot="card-subheader">Commodo sit veniam enim aute mollit ut qui.</div>
          <div slot="card-body">
            <v-list-item dark two-line>
              <v-list-item-content>
                <v-list-item-title class="text-h6">
                  San Francisco
                </v-list-item-title>
                <v-list-item-subtitle>Mon, 12:30 PM, Mostly sunny</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-card-text>
              <v-row class="center ">
                <v-col class="text-h3" cols="7">
                  23
                </v-col>
                <v-col cols="5">
                  <v-img src="../../assets/images/icon/chat.png" alt="Sunny image" width="102"></v-img>
                </v-col>
              </v-row>
            </v-card-text>


          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="4" sm="12">
        <base-card>
          <div slot="card-header">

            Weather forecast
          </div>
          <div slot="card-subheader">Commodo sit veniam enim aute mollit ut qui.</div>
          <div slot="card-body">
            <v-list-item dark two-line>
              <v-list-item-content>
                <v-list-item-title class="text-h6">
                  San Francisco
                </v-list-item-title>
                <v-list-item-subtitle>Mon, 12:30 PM, Mostly sunny</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-card-text>
              <v-row class="center">
                <v-col class="text-h3" cols="7">
                  23%
                </v-col>
                <v-col cols="5">
                  <v-img src="../../assets/images/icon/start.png" alt="Sunny image" width="102"></v-img>
                </v-col>
              </v-row>
            </v-card-text>


          </div>
        </base-card>
      </v-col>
    </v-row>

  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    data() {
      return {
        selectedItem: 2,
        fill: true,
        singleSelect: true,
        value: [
          423,
          446,
          675,
          510,
          590,
          610,
          760,
        ],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        pickerDate: null,
        notes: [],
        allNotes: [
          'President met with prime minister',
          'New power plant opened',
          'Rocket launch announced',
          'Global warming discussion cancelled',
          'Company changed its location',
        ],
        singleSelect: false,
        selected: [],
        headers: [{
            text: 'Autor',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          {
            text: 'Projects',
            value: 'email'
          },
          {
            text: 'Status',
            value: 'status'
          },
          {
            text: 'Role',
            value: 'role'
          }, {
            text: '%',
            value: 'iron'
          },

        ],
        desserts: [{
            name: 'Gitlab',
            email: 'Template',
            status: 'Activo',
            role: 'maintainer',
            iron: '40%',
            img: '13'

          },
          {
            name: 'Relax',
            email: 'Project Play',
            stautus: 'Inactivo',
            status: 'Activo',
            role: 'maintainer',
            iron: '1%',
            img: '7'
          },
          {
            name: 'Desise',
            email: 'Portfolio',
            status: 'Activo',
            role: 'Autor',
            protein: 6.0,
            img: '3',
            iron: '7%',
          }, {
            name: 'Github',
            email: 'Template',
            status: 'Activo',
            role: 'maintainer',
            iron: '40%',
            img: '13'

          },
          {
            name: 'Play',
            email: 'Project Play',
            stautus: 'Inactivo',
            status: 'Activo',
            role: 'maintainer',
            iron: '1%',
            img: '7'
          },
          {
            name: 'deise',
            email: 'Portfolio',
            status: 'Activo',
            role: 'Autor',
            protein: 6.0,
            img: '3',
            iron: '7%',
          },



        ],
        list1: [{
            color: 'primary',
            icon: 'headset_mic',
            subtitle: 'Active',
            title: 'Podcast',
            switch1: false

          }, {
            color: 'primary',
            icon: 'work_outline',
            subtitle: 'Active',
            title: 'Home Office',
            switch1: true

          },
          {
            color: 'primary',
            icon: 'monetization_on',
            subtitle: 'Active',
            title: 'Responsibility',
            switch1: false

          },
          {
            color: 'primary',
            icon: 'support',
            subtitle: 'Active',
            title: 'Forum Religion',
            switch1: false

          }, {
            color: 'primary',
            icon: 'language',
            subtitle: 'Active',
            title: 'Pray for World',
            switch1: true

          }, {
            color: 'primary',
            icon: 'diamond',
            subtitle: 'Active',
            title: 'Trade Bot',
            switch1: true
          }, {
            color: 'primary',
            icon: 'diamond',
            subtitle: 'Active',
            title: 'Tradechat',
            switch1: true
          }
        ],


        list2: [{
            color: 'accent',
            icon: 'trending_down',
            price: '-4%',
            title: 'BNB',
            switch1: false
          },
          {
            color: 'primary',
            icon: 'trending_up',
            price: '+14%',
            title: 'ENJ',
            switch1: false

          },
          {
            color: 'accent',
            icon: 'trending_down',
            price: '-4%',
            title: 'BNB',
            switch1: false
          },
          {
            color: 'primary',
            icon: 'trending_up',
            price: '+14%',
            title: 'ENJ',
            switch1: false

          }

        ],
        colors: [
          'green',
          'secondary',
          'yellow darken-4',
          'red lighten-2',
          'orange darken-1',
        ],
        cycle: false,
        slides: [
          'First',
          'Second',
          'Third',
          'Fourth',
          'Fifth',
        ],
      }
    },
    methods: {
      getColor(status) {
        if (status === 'Inactivo') return 'accent'
        else if (status == 'Neutro') return 'primary'
        else return 'primary'
      },
      getColor2(role) {
        if (role === 'maintainer') return 'primary'
        else if (role == 'Reader') return 'accent'
        else return 'accent'
      },

    },

  }
</script>

<!--====  End of WIDGETS LIST  ====-->
